<template>
  <div id="app">
    <router-view />
    <!-- <audio preload loop ref='audio' src='https://qd-operator.s3.cn-north-1.jdcloud-oss.com/hszq/yinpin/2d483ab9-46a2-4712-be7f-17dee780da63.mp3' @click='play'></audio> -->
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {},
  methods:{
    play(){
      let audio = this.$refs.audio
      if(audio.paused) audio.play()
      else audio.pause()
    }
  }
}

</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50;
  margin-top: 60px; */
}

body {
  margin: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important
}

*::scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent;
  display: none;
}

*::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent;
  display: none;
}

*::-webkit-scrollbar-thumb {
  width: 0 !important;
  height: 0 !important;
  background: transparent;
  display: none;
}

*::-webkit-scrollbar-track {
  width: 0 !important;
  height: 0 !important;
  background: transparent;
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue